module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="invite-card">\n    <div class="invite-cards__loader" style="display: none">\n        <div class="circle-loader"></div>\n    </div>\n\n    <div class="invite-card__content">\n        <div class="invite-card__position">' +
__e( position.title ) +
'</div>\n        <div class="invite-card__company">' +
__e( position.company_name ) +
'</div>\n        <div class="invite-card__interview">\n            ' +
__e( inviteType ) +
' &bull; Invited ' +
__e( inviteTime ) +
'\n        </div>\n        <div class="invite-card__links">\n            <a href="' +
__e( schedule_url ) +
'" class="invite-card__schedule-link">Schedule interview</a>\n            <a href="#" class="invite-card__withdraw-link" data-id="' +
__e( id ) +
'">I\'m no longer interested</a>\n        </div>\n    </div>\n\n    <div class="invite-card__withdraw" style="display: none">\n        <strong>Are you sure?</strong>\n        <p>We will withdraw your application</p>\n\n        <div class="link-group">\n            <a href="#" class="invite-card__withdraw-yes">Yes</a>\n            <a href="#" class="invite-card__withdraw-no">No</a>\n        </div>\n    </div>\n\n    <div class="invite-card__withdraw-success" style="display: none">\n        <strong>Thanks for letting us know!</strong>\n        <p>\n            We\'ve withdrawn your application for ' +
__e( position.title ) +
' - ' +
__e( position.company_name ) +
'\n        </p>\n    </div>\n</div>\n';

}
return __p
}